import type {ChangeEvent} from 'react'
import * as React from 'react'
import {useId} from 'react'

import {useAppSelector} from '../../../../../../../hooks/react-redux'

import FeedbackFormSection from './FeedbackForm.section'

import styles from './FeedbackForm.css'

function FeedbackFormComment({onTypeText}: {onTypeText: (text: string) => void}) {
  const textAreaRef = React.useRef<HTMLTextAreaElement>(null)
  const comment = useAppSelector(state => state.pipelines.feedbackForm.userInput.comment)

  const updateComment = React.useCallback(
    (event: ChangeEvent<HTMLTextAreaElement>) => {
      onTypeText(event.target.value)
    },
    [onTypeText],
  )

  React.useEffect(() => {
    textAreaRef.current?.focus()
  }, [])

  const id = useId()

  return (
    <FeedbackFormSection>
      <label htmlFor={id} className={styles.hint}>
        {'Additional feedback (Optional)'}
      </label>
      <textarea
        id={id}
        ref={textAreaRef}
        onChange={updateComment}
        value={comment}
        rows={5}
        className={styles.textarea}
      />
    </FeedbackFormSection>
  )
}

export default React.memo(FeedbackFormComment)
